var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('usage-by-month',{attrs:{"endpoint":"/api/team-credits","prefix":"Team/Members"}})}
var staticRenderFns = []

export { render, staticRenderFns }